// general app config
const config = {
    // alias account specifics
    aliasAccount: {
        emailSuffix: "@clubs.play-sports.app",
        legacyEmailSuffix: "@clubs.courtastic.de",
        passwordSuffix: "_bkf2VE",
        pinRegex: /^[0-9]{4}$/,
    },

    // api
    api: (process.env.REACT_APP_MODE === "prod") ? {
        guestToken: "guest-B2RVY95sA2A3ghRMU74hMDFsWhZtYLKF5JWYmMN88ZTv7CgW7JcYbcTWWrPjz3cK5LXaTcm5pMD4q6DZu7EwSBuP6GBUJgtVu6Mn8UaCFs4NcczLSxvNbMrjcZCcpyVK",
        url: "https://api.play-sports.org/",
        version: "v2",
    } : {
        guestToken: "guest-B2RVY95sA2A3ghRMU74hMDFsWhZtYLKF5JWYmMN88ZTv7CgW7JcYbcTWWrPjz3cK5LXaTcm5pMD4q6DZu7EwSBuP6GBUJgtVu6Mn8UaCFs4NcczLSxvNbMrjcZCcpyVK",
        url: "https://dev-api.play-sports.org/",
        version: "v2",
    },

    // bookings config
    bookings: {
        detailsDescriptionAbsoluteMaxLength: 1024, // including markdown syntax
        detailsDescriptionMaxLength: 400, // stripped
        getStrippedLength: (markdown: string) => markdown.replace(/\[([^\]]+)\]\([^)]+\)/gm, (_, linkText) => linkText).replace(/[#_*]/gm, "").length,
    },

    // AWS Cognito
    cognito: (process.env.REACT_APP_MODE === "prod") ? {
        oauth: {
            domain: "auth.playsports.world",
            redirectSignIn: "https://locations.playsports.world",
            redirectSignOut: "https://locations.playsports.world",
            responseType: "code",
            scope: ["phone", "email", "profile", "openid", "aws.cognito.signin.user.admin"],
        },
        region: "eu-central-1",
        userPoolId: "eu-central-1_yi4y4r0QG",
        userPoolWebClientId: "1m5o8tfc26npt12cco6a8i49pu",
    } : {
        oauth: {
            domain: "playsports.auth.eu-central-1.amazoncognito.com",
            redirectSignIn: "https://dev-locations.playsports.world",
            redirectSignOut: "https://dev-locations.playsports.world",
            responseType: "code",
            scope: ["phone", "email", "profile", "openid", "aws.cognito.signin.user.admin"],
        },
        region: "eu-central-1",
        userPoolId: "eu-central-1_Mrnb6NMvA",
        userPoolWebClientId: "lh021kne25dtblls62mqds6uj",
    },

    // documents cdn links
    documents: {
        adminManual: "https://cdn.play-sports.org/marketing/onboarding/PLAYSPORTS_Anleitung_Adminbereich_2021.pdf",
        contractAgreement: "https://cdn.play-sports.org/legal/club-contracts/Partnervertrag_playSports.pdf",
        contractSharedResponsibility: "https://cdn.play-sports.org/legal/club-contracts/GemeinsameVerantwortung_playSports.pdf",
        onboardingBundle: "https://cdn.play-sports.org/marketing/onboarding/PLAYSPORTS_OnboardingPaket_2021.zip",
        b2bPrivacy: "https://cdn.play-sports.org/legal/club-contracts/Datenschutzerklärung_playsports.pdf",
        b2bTermsOfUse: "https://cdn.play-sports.org/legal/club-contracts/Nutzungsbedingungen_playsports.pdf",
    },

    // GMaps geocoding api
    geocode: {
        apiKey: "AIzaSyCQ97oZSpWG7KtqV0KUm2KShW19vqy7iQw",
    },

    // helpscout beacon
    helpscout: {
        beaconId: "28f66363-f907-4e1d-9f5d-96a3a8a15ff4",
        B2BbeaconId: "a01f2b87-d60a-4569-8812-4b0e67ea5d34",
    },

    // links
    links: {
        registerClubRedirect: "https://playsports.world/neuerverein-danke",
        registerCompanyRedirect: "https://playsports.world/neuesunternehmen-danke/",
    },

    // stories config
    stories: {
        absoluteMaxLength: 1024, // including markdown syntax
        getStrippedLength: (markdown: string) => markdown.replace(/\[([^\]]+)\]\([^)]+\)/gm, (_, linkText) => linkText).replace(/[#_*]/gm, "").length,
        maxLength: 288, // stripped
    },

    // strip key
    stripe: (process.env.REACT_APP_MODE === "prod") ? {
        publishableKey: "pk_live_KcUIRJRjskVde6JrCwJxEfZK",
    } : {
        publishableKey: "pk_test_yphoIORI58CHPVWoqZFijBOV",
    },
};

export default config;
